import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AsyncPipe, DatePipe } from '@angular/common';
import { UrlInvoicePipe } from '../../../../shared/pipes/url-invoice/url-invoice.pipe';
import { PreLoaderModule } from '@ui/feedback/pre-loader/pre-loader.module';
import { NoMatchesComponent } from '@ui/feedback/no-matches/no-matches.component';
import { ListB2BInvoiceResponse } from '@api/models/B2bService/Contract/Invoice/list-b-2-b-invoice-response';
import { AbstractGridComponent } from '@ui/base/abstract-grid/abstract-grid.component';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { IconBsComponent } from '@ui/elements/icon-bs/icon-bs.component';
import { BsIconTypes } from '@ui/elements/icon-bs/bs-icon-types';
import { TranslatePipe } from '@ngx-translate/core';


/**
 * B2b invoices table
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'b2b-table-b2b-invoices',
    templateUrl: './table-b2b-invoices.component.html',
    styleUrls: ['./table-b2b-invoices.component.scss'],
    imports: [
        DatePipe,
        UrlInvoicePipe,
        PreLoaderModule,
        NoMatchesComponent,
        AsyncPipe,
        MatTableModule,
        MatSortModule,
        IconBsComponent,
        TranslatePipe,
    ],
})
export class TableB2bInvoicesComponent extends AbstractGridComponent<ListB2BInvoiceResponse> {
    @Input()
    public displayedColumns: string[] = ['number', 'period', 'date', 'amount', 'status', 'icons'];

    /**
     * Format date
     */
    @Input() public dateFormat: string;

    /**
     * Change status event
     *
     * @returns Invoice object
     */
    @Output() public changeInvoiceStatus: EventEmitter<ListB2BInvoiceResponse> = new EventEmitter<ListB2BInvoiceResponse>();

    @Input()
    public set invoices(invoices: ListB2BInvoiceResponse[]) {
        if (invoices) {
            this.displayEntities.data = invoices;
        }
    }

    protected readonly bsIconTypes: typeof BsIconTypes = BsIconTypes;
}
